export default {"src":"/_next/static/media/wish.971da5c7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};